import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import _clone from 'lodash/clone';
import _get from 'lodash/get';
import _has from 'lodash/has';
import {
  processing,
  updateAdminUserRole,
  getAdminUsersResult,
  getValidBrandsResult,
  updateAdminUserRoleResult,
} from './actions';

export const initialState = {
  processing: false,
  data: [],
  validBrands: null,
  updateRoleResult: null,
};

const reducer = handleActions(
  {
    [processing](state, action) {
      return update(state, { processing: { $set: action.payload } });
    },
    [getValidBrandsResult](state, action) {
      return update(state, {
        validBrands: { $set: action.payload },
      });
    },
    [getAdminUsersResult](state, action) {
      return update(state, {
        data: { $set: action.payload },
      });
    },
    [updateAdminUserRole](state) {
      return update(state, { updateRoleResult: { $set: null } });
    },
    [updateAdminUserRoleResult](state, action) {
      if (!_has(action.payload, 'error')) {
        const { data } = state;
        const { isAdmin, userId, brand } = action.payload;
        const updatedData = _clone(data);
        let user;
        if (Array.isArray(userId)) {
          // eslint-disable-next-line array-callback-return
          userId.map(id => {
            user = updatedData.find(el => el.id === id);
            user.isClientAdmin = isAdmin;
            if (isAdmin) {
              const userClientList = _get(user, 'adminInClients', []);
              userClientList.push(brand);
              user.adminInClients = userClientList;
              user.custom_role = 'Customer Admin';
            } else {
              const userClientList = _get(user, 'adminInClients', []).filter(
                item => item !== brand,
              );
              user.adminInClients = userClientList;
              user.custom_role = 'User';
            }
          });
        } else {
          user = updatedData.find(el => el.id === userId);
          user.isClientAdmin = isAdmin;
          if (isAdmin) {
            const userClientList = _get(user, 'adminInClients', []);
            userClientList.push(brand);
            user.adminInClients = userClientList;
            user.custom_role = 'Customer Admin';
          } else {
            const userClientList = _get(user, 'adminInClients', []).filter(
              item => item !== brand,
            );
            user.adminInClients = userClientList;
            user.custom_role = 'User';
          }
        }
        return update(state, {
          data: { $set: updatedData },
        });
      }
      return state;
    },
  },
  initialState,
);

export default reducer;
